<template>
  <div>
    <b-loading :active.sync="loading" />
    <div class="w-full flex justify-between items-center">
      <Lynx-Title text="DÚVIDAS CLIENTES" />

      <Lynx-Button
        text="Cadastrar"
        class="mb-8"
        icon-size="3"
        size="small"
        @click.native="cadastrar()"
      />
    </div>
    <!-- <div class="w-full flex justify-between items-center"> -->
    <!-- <label class="flex flex-col w-1/2 pb-6 pr-3"> -->
    <!-- <Lynx-Label label="Carteiras" /> -->
    <!-- 
        <treeselect
          :multiple="false"
          :options="lista_carteiras"
          placeholder="Selecione as carteiras..."
          v-model="carteira"
        />
      </label>
      <label class="flex flex-col w-1/5 pb-6 pt-4">
        <Lynx-Button
          text="Relatorio Clientes Textos"
          class="mb-4"
          @click.native="gerarRelatorio()"
          size="small"
          icon-size="3"
        />
      </label>
    </div> -->

    <b-table
      :columns="columns"
      :data="lista_texto_qualidade"
      :per-page="perPage"
      :paginated="true"
      default-sort-direction="asc"
      default-sort="id"
      hoverables
      class="w-full rounded-t-none"
    >
      <template slot-scope="props">
        <b-table-column field="setor" v-text="props.row.setor" />
        <b-table-column field="duvida" v-text="props.row.duvida" />


        <!-- <b-table-column field="tempo" v-text="props.row.tempo" /> -->

        <b-table-column field="criação">{{
          props.row.created_at | formatEnToBr
        }}</b-table-column>
            <b-table-column field="atualização">{{
          props.row.updated_at | formatEnToBr
        }}</b-table-column>
        <b-table-column  v-if="props.row.usuario" field="Incluído por" v-text="props.row.usuario.nome_completo" />
        <b-table-column  v-else field="Incluído por" v-text="'medcontabil'" />


        <b-table-column field="acoes">
          <div class="flex text-sm">
            <div class="flex text-sm items-center" >
              <a
                href="#"
                class="mr-4 bg-primary-600 rounded-full p-2"
                @click.prevent="atualizar(props.row)"
              >
                <Icon-Edit class="text-neutral-100" size="4" />
              </a>
              <a v-if="hasRole('Editor') | hasPermission('editar duvidas clientes')"
                href="#"
                class="mr-4 bg-error-base rounded-full p-2"
                @click.prevent="excluir(props.row)"
              >
                <Icon-Trash class="text-neutral-100" size="4" />
              </a>
            </div>
            <!-- <div class="flex text-sm items-center">
              <a
                href="#"
                class="mr-4 bg-primary-600 rounded-full p-2"
                @click.prevent="entrar(props.row)"
              >
                <Icon-Eye class="text-neutral-100" size="4" />
              </a>
            </div> -->
          </div>
        </b-table-column>
      </template>
      <template #empty>
        <Not-Found-Data text="Nenhuma Texto para a pesquisa informada" />
      </template>
    </b-table>

    <b-modal :active.sync="CadasModal" id="modal-tall">
      <div class="bg-neutral-300 p-8">
        <div class="modal-body">
          <Lynx-Title text="DÚVIDAS CLIENTES" ></Lynx-Title>
          <div class="flex flex-row-reverse ">
            <Input-File
              text="Arquivo qualidade"
              ref="arquivoQualidade"
            />
            <div class="w-1/4 mr-1">

          <b-select
            placeholder="Selecione um setor"
         
            v-model="form.setor_id"
          >
            <option
              v-for="(item, key) in setores"
              :key="key"
              :value="item.id"
            >
              {{item.label}}
            </option>
          </b-select>
          </div>
          </div>
          <div class="flex flex-row-reverse mt-1">
            <v-btn
              shaped
              color="primary"
              elevation="15"
              small
              v-if="lista_campos.arquivo"
              @click="openFile(lista_campos.arquivo.id)"
              >{{ lista_campos.arquivo["nome_original"] }}</v-btn
            >
          </div>

      
          <label class="">
            <Lynx-Label label="Duvida do cliente" />
            <Lynx-Textarea
            :disabled="!(hasRole('Editor') | hasPermission('editar duvidas clientes'))"
              placeholder="Insira a duvida"
              v-model="form.duvida"
              class="w-full"
            />
          </label>
          <label class="">
            <Lynx-Label label="Resposta para o cliente" />
            <Lynx-Textarea
            :disabled="!(hasRole('Editor') | hasPermission('editar duvidas clientes'))"
              placeholder="Insira a resposta"
              v-model="form.resposta"
              class="w-full"
            />
          </label>
          <button class="ml-2" @click="copyText(form.resposta)">
            <b-icon icon="content-copy" size="is-small"></b-icon>{{ copiado ? 'copiado' : 'copiar'  }}
          </button>
     
     
        </div>

        <div v-if="hasRole('Editor') | hasPermission('editar duvidas clientes')" class="flex justify-center mt-5">
          <Lynx-Button
            :text="!lista_campos.id ? 'cria' : 'edita'"
            class="mb-8 w-1/4"
            icon="Reload"
            @click.native="confirm(!lista_campos.id ? 'cria' : 'edita')"
            size="small"
            icon-size="3"
          />
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
// import Card from "@/components/helpers/Card";
// import Template from "../../components/icons/Template.vue";
import { searchEmpresasRequest } from "@/services/requests/empresas";
import debounce from "@/mixins/debounce";

import Treeselect from "@riophae/vue-treeselect";
import NotFoundData from "@/components/layouts/NotFoundData";
import InputFile from "@/components/helpers/InputFile";
import LynxTextarea from "@/components/helpers/Textarea";
import { mapGetters } from "vuex";

import { formatEnToBr } from "@/utils/momentHelpers";
import { hasRole, hasPermission } from "@/utils/can";

export default {
  mixins: [debounce],

  name: "index",
  components: {
    Treeselect,
    NotFoundData,
    InputFile,
    LynxTextarea,
  },
  filters: {
    formatEnToBr,
  },
  data() {
    return {
      copiado: false,
      form: {
        duvida: "",
        resposta: "",
        usuario_id: null,
        setor_id: null,
        arquivo_id: null,
      },
      status: [],
      isFetching: false,
      currentPage: 1,
      perPage: 10,
      loading: false,
      lista_campos: [],
      CadasModal: false,
      cliente: null,
      carteira: null,
      carteiras: [],

      columns: [
      {
          field: "setor",
          label: "setor",
          sortable: false,
          searchable: true,
        },
        {
          field: "duvida",
          label: "duvida",
          sortable: false,
          searchable: true,

        },

        {
          field: "created",
          label: "criação",
          sortable: true,
        },
        {
          field: "updated",
          label: "atualização",
          sortable: true,
        },
        {
          field: "usuario.nome_completo",
          label: "incluido por",
          sortable: true,
        },
      ],
      empresas: [],
      setores: [
        { id: 1, label: "Legalização & Onboarding" },
        { id: 2, label: "Contabilidade" },
        { id: 3, label: "Alteração/baixa" },
        { id: 4, label: "BDR" },
        { id: 5, label: "SDR" },
        { id: 6, label: "Closer" },
        { id: 7, label: "CS" },
        { id: 8, label: "Credenciamento" },
        { id: 9, label: "Financeiro" },
        { id: 10, label: "Seguro" },
      ],
    };

    
  },
  computed: {
    ...mapGetters(["getToken","getUser"]),
    lista_texto_qualidade() {
      let a  = this.$store.state.texto.lista_texto_qualidade;

    return   a.map(obj => {
  const setor = this.setores.find(item => item.id === obj.setor_id);
  return {
    ...obj,
    setor: setor ? setor.label : null,
  };
});

    },
    mensagem_alert() {
      return this.$store.state.texto.mensagem_alert;
    },
  },
  created() {
    this.listar_texto_qualidade();
  },
  methods: {
    hasRole,
    hasPermission,
    copyText(value) {
      this.$copyText(value);
      this.copiado = value;
      setTimeout(() => (this.copiado = false), 1500);
    },
    async confirm(tipo) {
      await this.$buefy.dialog.confirm({
        message: `Esta ação  ` + tipo + ` duvidas de clientes no sistema?`,
        confirmText: "Sim",
        cancelText: "Não",
        type: "is-success",
        onConfirm: () => {
          if (tipo == "cria") this.create();
          if (tipo == "edita") this.update();
          if (tipo == "excluir") this.exclui();

        },
      });
    },
    async create() {
      if (this.$refs.arquivoQualidade) {
        this.form.arquivo_id = await this.$refs.arquivoQualidade.submit();
      }
      this.form.usuario_id =this.getUser.id
      this.$store.dispatch("configEmpresa/atualizar", "");
      // console.log(this.form);
      this.loading = true;
      await this.$store
        .dispatch("texto/create_texto_qualidade", this.form)
        .then(() => {
          this.$snack.success(this.mensagem_alert.message);
          this.CadasModal = false;
          this.listar_texto_qualidade();
        })
        .catch((error) => this.$snack.error(mensagem_alert.message))
        .finally(() => (this.loading = false));
    },
    openFile(arquivo) {
      window.open(
        `${process.env.VUE_APP_API_URL}/arquivos/${arquivo.id}/open?token=${this.getToken}`
      );
    },

    async update() {
      this.form.usuario_id =this.getUser.id

      await this.$store
        .dispatch("texto/update_texto_qualidade", this.form)

        .then(() => {
          this.$snack.success(this.mensagem_alert.message);
          this.CadasModal = false;
        })
        .catch((error) => this.$snack.error(mensagem_alert.message))
        .finally(() => (this.loading = false));
      this.listar_texto_qualidade();

      //   this.fireAlert({
      //     ...this.mensagem_alert,
      //     routeName: "produto",
      //   });
    },

    async listar_texto_qualidade() {
      // this.$store.dispatch("carteira/listar_carteiras");

      await this.$store.dispatch("texto/listar_texto_qualidade");

      this.$store.dispatch("configEmpresa/atualizar", "");
    },

    cadastrar() {
      this.atualizar("");

      this.CadasModal = true;
    },
    atualizar(value) {
      this.lista_campos = value;

      this.form.id = value.id;
      this.form.arquivo = value.arquivo;
      this.form.duvida = value.duvida;
      this.form.resposta = value.resposta;
      this.form.setor_id = value.setor_id;


      // this.form.tempo = value.tempo;

      this.CadasModal = true;
    },
    excluir(value){
      this.lista_campos = value;
      this.confirm('excluir')
    },

  async  exclui(){
      await this.$store
        .dispatch("texto/delete_texto_qualidade", this.lista_campos)
        .then(() => {
          this.$snack.success(this.mensagem_alert.message);
          this.listar_texto_qualidade();
        })
        .catch((error) => this.$snack.error(mensagem_alert.message))
    },
    entrar(value) {
      //  this.$router.push({path: 'empresas.show'})
      this.$router.push({ path: `/texto/etapas/${value.id}` });
    },

    // gerarRelatorio() {
    //   window.open(
    //     `${process.env.VUE_APP_API_URL}/api/Textos/relatorio/clientes/?token=${this.$store.getters.getToken}&carteira_id=${this.carteira}`,
    //     "_blank"
    //   );
    // },
  },
};
</script>

<style scoped>
</style>
